import { addLoader } from '../../shared/shared';
import Handlebars from '../../shared/handlebar-helpers';

export const prepareNewCart = async (service, session) => {
    const {id: cartId} = await service.getCartDetails() ?? {id: null, version: null};
    if (cartId) {
        await service.deleteCart(cartId);
    }
    session.sessionDetails = session.getBaseSession().sessionDetails;
}

export const handleNewCartClick = async (e, app) => {
    const content = e.currentTarget.querySelector('#adv-load-content');
    
    addLoader(content, `${Handlebars.translation.menu.deleting_cart}...`);
    await prepareNewCart(app.service, app.session);
    addLoader(content, `${Handlebars.translation.general.redirecting}...`);
    return (window.location.href = '/');
};